import { render, staticRenderFns } from "./Register-Verify.vue?vue&type=template&id=ff2ad3e6"
import script from "./Register-Verify.vue?vue&type=script&lang=js"
export * from "./Register-Verify.vue?vue&type=script&lang=js"
import style0 from "./Register-Verify.vue?vue&type=style&index=0&id=ff2ad3e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports